import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M26.667 5H5.333A2.663 2.663 0 0 0 2.68 7.667l-.013 16c0 1.466 1.2 2.666 2.666 2.666h21.334c1.466 0 2.666-1.2 2.666-2.666v-16C29.333 6.2 28.133 5 26.667 5m0 5.333L16 17 5.333 10.333V7.667L16 14.333l10.667-6.666z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }